// src/ui/screens/post/widgets/AtomRecommendedUsersCard.jsx
//
// TikTok-style "Suggested accounts" full-screen slide dropped into the
// Atoms feed. Fills its slot exactly like VideoItem does, so it snaps
// into the vertical feed the same way.

import UserRecommendationItem from './UserRecommendationItem';

const BG = '#08090B';
const ORANGE = '#FF8C08';

export default function AtomRecommendedUsersCard({ users, onSeeMore }) {
  return (
    <div className="w-full h-full flex flex-col items-center justify-center px-5" style={{ backgroundColor: BG }}>
      <svg style={{ width: 38, height: 38, color: ORANGE }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M17 20h5v-2a4 4 0 00-3-3.87M9 20H4v-2a4 4 0 013-3.87m6-3.13a4 4 0 10-4-4 4 4 0 004 4zm6 0a4 4 0 10-4-4"
        />
      </svg>
      <div style={{ height: 12 }} />
      <h3 className="text-white text-xl font-extrabold">Recommended for you</h3>
      <div style={{ height: 6 }} />
      <p className="text-white/50 text-[13px] text-center">People you might want to follow on Filatom</p>
      <div style={{ height: 24 }} />

      <div className="flex-1 w-full overflow-y-auto">
        {!users || users.length === 0 ? (
          <div className="h-full flex items-center justify-center">
            <span className="text-white/30 text-[13px]">No suggestions right now</span>
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-3.5">
            {users.map((user) => (
              <UserRecommendationItem key={user.id} user={user} width="100%" />
            ))}
          </div>
        )}
      </div>

      <div style={{ height: 16 }} />
      <button onClick={onSeeMore} className="w-full rounded-[10px] py-3.5" style={{ backgroundColor: ORANGE }}>
        <span className="text-black text-sm font-bold">See more people</span>
      </button>
      <div style={{ height: 20 }} />
    </div>
  );
}

export { AtomRecommendedUsersCard };